<template>
    <div class="assignment-step" v-if="canViewStep">

        <div class="page-content">
            <h1>Klaar!</h1>
            <celebration :type="termCelebration"></celebration>

            <group-submissions :assignment="assignment" :group="group"></group-submissions>
            <assignment-feedback :assignment="assignment"></assignment-feedback>
        </div>

        <nav class="action-nav">
            <hr class="flipped">
            <router-link :to="{ name: 'assignment.step', params: { stepIdx: assignment.steps.length }}" class="tag button-timid button-backward">Vorige stap</router-link>
            <primary-button :link="returnLink.route" class="action-nav__next" >Klaar</primary-button>
        </nav>

    </div>
</template>


<script>
import step from './stepMixin'

import GroupSubmissions from './presenters/GroupSubmissions.vue'
import AssignmentFeedback from './partials/AssignmentFeedbackPartial.vue'
import Celebration from 'js/components/elements/Celebration.vue'

export default {
    name: 'Done',
    mixins: [ step ],
    props: {
        group: {},
        returnLink: {
            type: Object,
            required: true
        }
    },
    components: { GroupSubmissions, AssignmentFeedback, Celebration },
    data: function() {
        return {
            loading: false
        }
    },
    computed: {
        previousStep: function() {
            const previousStepIndex = this.steps.length - 1

            if ( previousStepIndex < 0 ) {
                return null
            }

            return this.steps[previousStepIndex]
        },
        canViewStep: function() {
            return this.isProgressFinished(this.progress)
        },
        termCelebration: function() {
            const currentGroupTerm = this.group.currentGroupTerm ? this.group.currentGroupTerm[0] : 0
            const termIndex = this.group.groupTerms.indexOf(currentGroupTerm)
            return termIndex % 2 == 0 ? 'confetti' : 'fireworks'
        },
    },
    methods: {
        checkRoute: function() {

            if ( ! this.canViewStep ) {
                this.autoRedirectStep(this.progress)
            }

        }
    },
    created: function() {
        this.checkRoute()
    },
}
</script>


<style lang="scss">

    @import 'global';

</style>



// WEBPACK FOOTER //
// StepDone.vue?ccb0b252